import PropTypes from 'prop-types';

var propTypes = {
    columnCount: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
    cellClassName: PropTypes.string,
    cellContainerClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    cellContentRenderer: PropTypes.func.isRequired,
    columnWidth: PropTypes.oneOfType([PropTypes.func, PropTypes.number])
        .isRequired,
    showScrollButton: PropTypes.bool,
    classNameBottomRightGrid: PropTypes.string,
    classNameBottomLeftGrid: PropTypes.string,
    classNameTopRightGrid: PropTypes.string,
    classNameTopLeftGrid: PropTypes.string,
};
var defaultProps = {
    showScrollButton: false,
    cellContainerClassName: '',
};

export { defaultProps, propTypes };
